import axios from 'axios'
import qs from 'qs'
import AsyncStorage from '@react-native-async-storage/async-storage'


const TEST_USERNAME = '4565825969'
const TEST_PASSWORD = '11111'
const TEST_PIN = '1111'
const TEST_CASH_ID = 3264
const TEST_BASE_URL = 'https://ws.lwo.by:8243/wcoperations/v1/'
const TEST_AUTH_URL = 'https://ws.lwo.by:8243'
const TEST_AUTH_KEY = 'Basic bExKbWREMElkX0pMNWN4WEJyR1Z5WWlUaVJBYTpmNHluZUQyMlk4bjYzZHhNMm90SWppcEcyS3Nh'


const BASE_URL = 'https://api.lkassa.kz/wcoperations/v1/'
const AUTH_URL = 'https://api.lkassa.kz/'
const AUTH_KEY = 'Basic bDVpamRUMmRLNnpLOXg4RnVjaXFobUhBUnU4YTpraXZuTWF0dWFMZUViZjZNMDBDMmlSRnZJNXNh'

var accessToken = null
var refreshToken = null
var accessTokenDate = null
var refreshTokenDate = null


export const setNewLKTokens = async (LKCredentials, store) => {
  // get completely new refresh and access tokens
  try {
    const [LKAccessToken, LKRefreshToken] = await getNewTokens(LKCredentials)
    accessToken = LKAccessToken
    refreshToken = LKRefreshToken
    accessTokenDate = new Date()
    accessTokenDate.setMinutes(accessTokenDate.getMinutes() + 55)
    refreshTokenDate = new Date()
    refreshTokenDate.setHours(refreshTokenDate.getHours() + 24)
    //save to cache
    const newTokens = {
      accessToken,
      accessTokenDate,
      refreshToken,
      refreshTokenDate,
    }
    await AsyncStorage.setItem('LKTokens' + store, JSON.stringify(newTokens))
  } catch (error) {
    handleError(error)
  }
}

export const loadLKTokensFromCache = async (store) => {
  const LKTokensString = await AsyncStorage.getItem('LKTokens' + store)
  if (LKTokensString != null) {
    const LKTokens = JSON.parse(LKTokensString)
    accessToken = LKTokens.accessToken
    accessTokenDate = LKTokens.accessTokenDate
    refreshToken = LKTokens.refreshToken
    refreshTokenDate = LKTokens.refreshTokenDate
  }
}

export const checkLKTokens = async (LKCredentials, store) => {
  try {
    if (accessToken) {
      if (new Date(accessTokenDate) < new Date()) {
        if (new Date(refreshTokenDate) < new Date()) {
          // get completely new refresh and access tokens
          await setNewLKTokens(LKCredentials, store)
        } else {
          // get new access token with refresh token
          accessToken = await refreshAccessToken()
          accessTokenDate = new Date()
          accessTokenDate.setMinutes(accessTokenDate.getMinutes() + 55)
          const newTokens = {
            accessToken,
            accessTokenDate,
            refreshToken,
            refreshTokenDate,
          }
          await AsyncStorage.setItem('LKTokens' + store, JSON.stringify(newTokens))
        }
      } 
    } else {
      // get completely new refresh and access tokens
      await setNewLKTokens(LKCredentials, store)
    }
  } catch (error) {
    handleError(error)
  }
}

export const getNewTokens = async (LKCredentials) => {
  try {
    const response = await axios.request({
      url: '/token',
      method: 'post',
      headers: {
        Authorization: AUTH_KEY,
      },
      baseURL: AUTH_URL,
      data: qs.stringify({
        scope: 'openid',
        grant_type: 'password',
        username: LKCredentials.username,
        password: LKCredentials.password, 
      })
    })
    return [response.data.access_token, response.data.refresh_token] 
  } catch (error) {
    handleError(error)
  }
}

export const refreshAccessToken = async () => {
  try {
    const response = await axios.request({
      url: '/token',
      method: 'post',
      headers: {
        Authorization: AUTH_KEY,
      },
      baseURL: AUTH_URL,
      data: qs.stringify({
        refresh_token: refreshToken,
        grant_type: 'refresh_token',
      })
    })
    return response.data.access_token
  } catch (error) {
    handleError(error)
  }
}

export const getCurrentShifts = async () => {
  try {
    const response = await axios.request({
      url: '/currentshifts',
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + accessToken,
      },
      baseURL: BASE_URL,
    })
    return response.data
  } catch (error) {
    handleError(error)
  }
}

export const createShift = async (LKCredentials) => {
  try {
    const response = await axios.request({
      url: '/shifts',
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'pin': LKCredentials.pin,
      },
      baseURL: BASE_URL,
      data: {
        'cashId': LKCredentials.cashId
      }
    })
    return response.data
  } catch (error) {
    handleError(error)
  }
}

export const closeShift = (LKCredentials) => axios.request({
  url: '/shifts',
  method: 'DELETE',
  headers: {
    Authorization: 'Bearer ' + accessToken,
    'pin': LKCredentials.pin,
  },
  baseURL: BASE_URL,
}).then(response => {
  return response.data
})

export const getReceipts = (shiftId) => axios.request({
  url: '/shifts/' + shiftId + '/tickets',
  method: 'get',
  headers: {
    Authorization: 'Bearer ' + accessToken,
  },
  baseURL: BASE_URL,
}).then(response => {
  return response.data.tickets
})

export const getReceipt = (ticketId) => axios.request({
  url: '/tickets/' + ticketId,
  method: 'get',
  headers: {
    Authorization: 'Bearer ' + accessToken,
  },
  baseURL: BASE_URL,
}).then(response => {
  return response.data
})

export const saveFiscalOperation = async (LKCredentials, cartInfo, store) => {
  var items = []
  for (const [index, value] of cartInfo.cartItems.entries()) {
    const newItem = {
      "itemType": "1",
      "name": value.name,
      "sectionCode": "Секция 1",
      "depId": 0,
      "quantity": value.quantity,
      "price": value.salePrices[store],
      "sum": value.finalItemPrice,
      "taxes": [],
      "exciseStamp": null,
      "commodityId": null,
      "commoditySrc": 0
    }
    items.push(newItem) 
  }
  var payments = [
    {
      "paymentType": (cartInfo.paymentMethod.isCash ? 0 : 1),
      "sum": cartInfo.finalTotalCartPrice
    }
  ]
  if (cartInfo.mixedPayment) {
    payments = [
      {
        "paymentType": (cartInfo.paymentMethod.isCash ? 0 : 1),
        "sum": cartInfo.paymentMethod.value
      },
      {
        "paymentType": (cartInfo.secondPaymentMethod.isCash ? 0 : 1),
        "sum": cartInfo.secondPaymentMethod.value
      },
    ]
  }
  try {
    const response = await axios.request({
      url: '/tickets?receiptWidth=50',
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'pin': LKCredentials.pin,
      },
      baseURL: BASE_URL,
      data: {
        "ticketType": "2",    
        "items": items,
        "payments": payments,
        "amountTotal": cartInfo.finalTotalCartPrice,
        "amountTaken": cartInfo.finalTotalCartPrice,
        "amountChange": 0,
        "amountMarkup": 0,
        "amountDiscount": 0,
        "customerEmail": "",
        "customerPhone": "",
        // "clientRequestId": clientRequestId,
        "attrs": null
      }
    })
    return response.data
  } catch (error) {
    handleError(error)
  }
}

export const saveFiscalReturn = async (LKCredentials, cartInfo, store) => {
  var items = []
  for (const [index, value] of cartInfo.cartItems.entries()) {
    const newItem = {
      "itemType": "1",
      "name": value.name,
      "sectionCode": "Секция 1",
      "depId": 0,
      "quantity": value.quantity,
      "price": value.salePrices[store],
      "sum": value.finalItemPrice,
      "taxes": [],
      "exciseStamp": null,
      "commodityId": null,
      "commoditySrc": 0
    }
    items.push(newItem) 
  }
  var payments = [
    {
      "payment_method": (cartInfo.paymentMethod.isCash ? 0 : 1),
      "sum": cartInfo.finalTotalCartPrice
    },
  ]
  if (cartInfo.mixedPayment && cartInfo.secondPaymentMethod) {
    payments = [
      {
        "payment_method": (cartInfo.paymentMethod.isCash ? 0 : 1),
        "sum": cartInfo.paymentMethod.value
      },
      {
        "payment_method": (cartInfo.secondPaymentMethod.isCash ? 0 : 1),
        "sum": cartInfo.secondPaymentMethod.value
      },
    ]
  }
  try {
    const response = await axios.request({
      url: '/tickets?receiptWidth=50',
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'pin': LKCredentials.pin,
      },
      baseURL: BASE_URL,
      data: {
        "ticketType": "3",    
        "items": items,
        "payments": payments,
        "amountTotal": cartInfo.finalTotalCartPrice,
        "amountTaken": cartInfo.finalTotalCartPrice,
        "amountChange": 0,
        "amountMarkup": 0,
        "amountDiscount": 0,
        "customerEmail": "",
        "customerPhone": "",
        // "clientRequestId": clientRequestId,
        "attrs": null
      }
    })
    return response.data
  } catch (error) {
    handleError(error)
  }
}

export const getCurrentShiftStats = async () => {
  try {
    const response = await axios.request({
      url: '/currentshift/stats',
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + accessToken,
      },
      baseURL: BASE_URL,
    })
    return response.data
  } catch (error) {
    handleError(error)
  }
}

const handleError = (error) => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(error.response.data)
    console.log(error.response.status)
    console.log(error.response.headers)
  } else if (error.request) {
    // The request was made but no response was received
    console.log(error.request)
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message)
  }
  console.log(error.config)
}
